import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
import { useNavigateToList } from '@/hooks/useNavigateToList'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ShippingLineForm } from '@/components/forms/ShippingLineForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditShippingLinePage() {
  const colors = useThemeColors()
  const navigateToList = useNavigateToList('/shipping-lines')
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined

  const handleSuccess = () => {
    navigateToList()
  }

  const handleCancel = () => {
    navigateToList()
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Shipping Line
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Shipping Line details
            </Text>
          </CardHeader>
          <CardBody>
            <ShippingLineForm shippingLineId={numericId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


